import all from './all';
import list from './list';
import edit from './edit';
import add from './add';
import logs from './logs';

const module = {
  namespaced: true,
  modules: {
    all,
    list,
    edit,
    add,
    logs,
  },
};

export default module;
